/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < Mylavarapu Sarath Sai, Amal Sabu, Ujjwal Singh >

*/

// Also called as doc-review
const defaultState = {
  loading: false,
  doctorAnnotationPatientList: [],
  selectedDoctorAnnotationPatientList: [],
  totalAnnotationPatientsCount: 0,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case "GET_ALL_DOCTOR_ANNOTATION_PATIENTS": {
      return {
        ...state,
        selectedDoctorAnnotationPatientList: [],
        doctorAnnotationPatientList: action.payload.annotationPatients?.data,
        totalAnnotationPatientsCount: action.payload.count,
      };
    }
    case "SAVE_DOCTOR_ANNOTATION_PATIENT": {
      return {
        ...state,
        doctorAnnotationPatientList: action.payload?.annotationPatients?.data,
      };
    }
    case "SELECTED_VIEW_PATIENT_LIST_DATA": {
      return {
        ...state,
        selectedDoctorAnnotationPatientList: action.payload,
        loading: false,
      };
    }
    default:
      return state;
  }
  return state;
};
